import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import { Box } from "@mui/material";
import { AppAlert, ParagraphText, UBInput } from "../../../Libraries";
import TabAutoComplete from "../../../Libraries/TabAutoComplete";
import { itemValueLimit } from "../../Features/NewInvoiceBook/invoiceBookUtils";
import { CloseIcon, ItemCloseIcon } from "../../../assets/icons/icon";
import styles from "./AddQuickBody.module.css";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const AddQuickBody = ({
  index,
  name,
  qty,
  price,
  handleItemClick = () => { },
  handleDeleteItem,
  handleAddStock = () => { },
  handleUpdateQuantity = () => { },
  handleUpdatePrice = () => { },
  onUpdateStockPrice = () => { },
  isAddfromStock = false,
  allItems,
  id = "",
}) => {
  const [I18n] = useContext(LanguageContext);

  const [popoverOpen, setPopoverOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const priceRef = useRef(null);
  const [tempPrice, SetTempPrice] = useState()
  const itemList = useMemo(
    () =>
      (allItems || []).map((it) => ({
        ...it,
        value: it.name || "",
        label: it.name || "",
      })),
    [allItems],
  );

  useEffect(() => {
    SetTempPrice(price)
  }, [])

  const handlePriceSave = useCallback(
    (e) => {
      const rawPrice = +tempPrice;
      if (
        price !== rawPrice &&
        isAddfromStock
      ) {
        setAnchorEl(e?.currentTarget ?? e?.target ?? null);
        setPopoverOpen(true);
        priceRef.current.blur();
        return;
      }
    },
    [isAddfromStock, price, tempPrice]);

  const handleConfirmStockUpdate = useCallback(() => {
    const rawPrice = +price;
    SetTempPrice(price)
    onUpdateStockPrice(rawPrice);
    setPopoverOpen(false);
    setAnchorEl(null);
    setTimeout(() => priceRef.current.blur(), 500)
  }, [onUpdateStockPrice]);

  const handleDismissStockPrompt = () => {
    setPopoverOpen(false);
    setAnchorEl(null);
  }

  return (
    <div className={`${styles.row} invoiceItemTableRow`} key={index}>
      <div
        className={`${styles.cell} invoiceItemTableCell`}
      >
        <Box className={`${styles.itemNameAutocomplete} tabAutoCompleteBox addItemInpWrapperQuick`}>
          <TabAutoComplete
            id={`${id}_enter_item_name`}
            list={itemList}
            value={name || ""}
            handleSelect={(item) => {
              triggerLogEvent(analytics, "sb_quick_body_item_selected", { item_name: item?.name });
              handleItemClick(item?._raw);
            }}
            handleCreate={(search) => {
              triggerLogEvent(analytics, "sb_quick_body_item_created", { item_name: search });
              handleAddStock(search);
            }}
            asCreate="item"
            requireSearchToCreate
            placeholder={I18n.enter_item_name}
            hideCloseIcon={true}
          />
        </Box>
      </div>
      <div
        className={`${styles.cell} invoiceItemTableCell`}
      >
        <UBInput
          inputId={`${id}_enter_item_qty`}
          placeholder={"0"}
          baseClassname="addItemInpWrapper"
          className="add_item_inp hide_spinner"
          onChange={(key, value) => {
            handleUpdateQuantity(value);
          }}
          onBlur={(e) => {
            if (e.target.value == 0) {
              if (handleDeleteItem) handleDeleteItem();
            }
          }}
          value={qty}
          max={999999}
          disabled={!Boolean(name)}
        />
      </div>
      <div
        className={`${styles.cell} invoiceItemTableCell`}
      >
        <UBInput
          inputId={`${id}_enter_item_price`}
          placeholder={I18n.enter_price}
          baseClassname="addItemInpWrapper"
          className="add_item_inp hide_spinner"
          onChange={(key, value) => {
            handleUpdatePrice(value, itemValueLimit, 0);
          }}
          onBlur={handlePriceSave}
          onKeyDown={(e) => {
            if (e.key === "Enter") handlePriceSave(e);
          }}
          inputRef={priceRef}
          max={itemValueLimit}
          value={price != undefined ? `Rs. ${price}` : ""}
          disabled={!Boolean(name)}

        />
        <AppAlert
          open={popoverOpen}
          anchorEl={anchorEl}
          onClose={handleDismissStockPrompt}
          onConfirm={handleConfirmStockUpdate}
          onCancel={handleDismissStockPrompt}
          title={I18n.update_item_price}
          message={I18n.stock_list_desc}
        />
      </div>

      <div className={`${styles.cellActions} invoiceItemActionCell`}>
        {handleDeleteItem ? (
          <div
            role="button"
            id={`${id}_item_delete`}
            className={`${styles.deleteButton} cursorPointer`}
            onClick={handleDeleteItem}
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.keyCode === 13) {
                handleDeleteItem();
              }
            }}
          >
            {" "}
            <ItemCloseIcon />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AddQuickBody;
